"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const serializeLocation = (request) => ["hash", "host", "hostname", "href", "origin", "pathname", "port", "protocol", "search"].reduce((obj, key) => {
    return { ...obj, [key]: request[key] };
}, {});
exports.default = serializeLocation;
